import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable } from 'rxjs';

import { MAX_USE_ADD_COMPARTMENT } from 'src/environments/runtime';

export interface iFrontLoadingState {
  maxAddCompartment: number;
  addCompartmentCount: number;
  spacesAvailable: number;
}

const DEFAULT_FRONT_LOADING_STATE: iFrontLoadingState = {
  maxAddCompartment: Number(MAX_USE_ADD_COMPARTMENT),
  addCompartmentCount: 0,
  spacesAvailable: 0,
};

@Injectable({ providedIn: 'root' })
export class FrontLoadingStore extends ComponentStore<iFrontLoadingState> {
  private static _instance: FrontLoadingStore;
  constructor() {
    super(DEFAULT_FRONT_LOADING_STATE);

    if (!FrontLoadingStore._instance) {
      FrontLoadingStore._instance = this;
    }
    return FrontLoadingStore._instance;
  }

  readonly store$: Observable<iFrontLoadingState> = this.select((state) => state);

  readonly useAddCompartment = this.updater((state, addCompartmentCount: number) => {
    return {
      ...state,
      addCompartmentCount: state.addCompartmentCount + addCompartmentCount,
      spacesAvailable: state.spacesAvailable - 1,
    };
  });

  readonly decreaseSpacesAvailable = this.updater((state) => {
    return {
      ...state,
      spacesAvailable: state.spacesAvailable - 1,
    };
  });

  readonly resetAddCompartmentCount = this.updater((state, addCompartmentCount: number) => {
    return {
      ...state,
      addCompartmentCount,
    };
  });

  readonly updateSpacesAvailable = this.updater((state, spacesAvailable: number) => {
    return {
      ...state,
      spacesAvailable,
    };
  });
}
